import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { SelectModule } from 'primeng/select';
import { TranslationStateService } from '../../../shared/services/translation-state.service';
import { MenuItem } from 'primeng/api';
import { FooterComponent } from '../../pages/home/components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoggedUserStateService } from '../../services/logged-user-state.service';

@Component({
  selector: 'app-external',
  imports: [
    RouterOutlet,
    MenubarModule,
    MenuModule,
    TranslateModule,
    ButtonModule,
    SelectModule,
    FormsModule,
    FooterComponent,
    NavbarComponent,
    ProgressSpinnerModule,
  ],
  templateUrl: './external.component.html',
  styleUrl: './external.component.scss',
})
export class ExternalComponent implements OnInit {
  private translationStateService = inject(TranslationStateService);
  private loggedUserStateService = inject(LoggedUserStateService);

  menuItems: MenuItem[] = [];

  languageSelected: string = this.translationStateService.locale();

  itemsPopUp: MenuItem[] = [];

  loading = computed(
    () => this._loading() || this.loggedUserStateService.isLoading()
  );

  private _loading = signal(false);

  ngOnInit(): void {}

  setLanguage(): void {
    this.translationStateService.setLanguage(this.languageSelected);
  }

  isSelectedLanguage(lang: string): boolean {
    return this.languageSelected === lang;
  }

  setLoading(loading: boolean): void {
    this._loading.set(loading);
  }
}
